import type { CSSProperties, ReactNode } from 'react'

import styles from './StudioLayout.module.css'

interface StudioLayoutProps {
  left?: ReactNode
  children: ReactNode
  right?: ReactNode
  leftWidth?: number
  rightWidth?: number
}

export default function StudioLayout({
  left,
  children,
  right,
  leftWidth = 240,
  rightWidth = 300,
}: StudioLayoutProps) {
  const leftStyle = { width: `${leftWidth}px` } as CSSProperties
  const rightStyle = { width: `${rightWidth}px` } as CSSProperties

  return (
    <div className={styles.columns}>
      {left && (
        <aside className={styles.leftRail} style={leftStyle}>
          {left}
        </aside>
      )}
      <main className={styles.center}>{children}</main>
      {right && (
        <aside className={styles.rightRail} style={rightStyle}>
          {right}
        </aside>
      )}
    </div>
  )
}
